import { ChevronDown } from "lucide-react";
import React from "react";
import { Input } from "shared/components/inputs/Input";
import { ToggleSwitch } from "shared/components/toggleswitch/ToggleSwitch";
import { PriceInput } from "../../inputs/PriceInput";
import styles from "./Detalhes.module.scss";

interface Option {
  value: string;
  label: string;
}

interface DetalhesProps {
  modo?: "cadastro" | "edicao";
  register: any;
  errors: any;
  lojas: Option[];
  categorias: Option[];
  watch: any;
  setValue: any;
  status: "Em Estoque" | "Fora de Estoque" | "Encomendado";
  isActive: boolean;
  onChangeStatus: (v: "Em Estoque" | "Fora de Estoque") => void;
  onChangeIsActive: (v: boolean) => void;
}

export const Detalhes: React.FC<DetalhesProps> = ({
  register,
  errors,
  lojas,
  categorias,
  watch,
  setValue,
  isActive,
  onChangeIsActive,
}) => {
  return (
    <div className={styles.formContainer}>
      {/* TÍTULO */}
      <div className={styles.containerInput}>
        <label className={styles.inputLabel}>Nome do Produto</label>
        <Input
          name="name"
          placeholder="Digite o nome do produto"
          type="text"
          register={register}
          error={errors?.name?.message}
          customClass={styles.customInput}
        />
      </div>

      {/* DESCRIÇÃO */}
      <div className={styles.containerInput}>
        <label className={styles.inputLabel}>Descrição</label>
        <Input
          name="descricao"
          placeholder="Descreva o Produto"
          type="textarea"
          register={register}
          error={errors?.descricao?.message}
          customClass={styles.customTextArea}
        />
      </div>

      <div className={styles.containerLojaCategoria}>
        <div className={styles.containerInput}>
          <label className={styles.inputLabel}>Nome da Loja</label>
          <Input
            type="select"
            name="loja"
            placeholder="Escolha a Loja"
            icon={<ChevronDown size={16} />}
            options={lojas}
            register={register}
            error={errors?.loja?.message}
            customClass={styles.customSelect1}
          />
        </div>

        <div className={styles.containerInput}>
          <label className={styles.inputLabel}>Categoria</label>
          <Input
            type="select"
            name="categoria"
            placeholder="Selecione a categoria"
            icon={<ChevronDown size={13} />}
            options={categorias}
            register={register}
            error={errors?.categoria?.message}
            customClass={styles.customSelect}
          />
        </div>
      </div>

      <div className={styles.container2Inputs}>
        {/* PREÇO */}
        <div className={styles.containerInput}>
          <label className={styles.inputLabel}>Preço</label>
          <PriceInput
            value={watch("price")}
            onChange={(cents) => setValue("price", cents)}
            customClass={styles.customPrice}
            error={errors?.price?.message}
          />
        </div>

        {/* ESTOQUE */}
        <div className={styles.containerInput}>
          <label className={styles.inputLabel}>Estoque</label>
          <Input
            name="estoque"
            type="number"
            placeholder="QTD"
            register={register}
            error={errors?.estoque?.message}
            customClass={styles.inputUnit}
          />
        </div>
      </div>

      <div className={styles.containerToggle}>
        <label className={styles.inputLabel}>Produto Ativo</label>
        <ToggleSwitch
          value={isActive}
          onChange={onChangeIsActive}
        />
      </div>
    </div>
  );
};